<template>
  <div class="auth theme-turquoise">
    <!-- Brand panel — black with the Valsplat VP1 pattern, echoes the
         in-app TopBar brand mark. Hidden on narrow screens. -->
    <aside class="auth__brand" aria-hidden="true">
      <div class="auth__brand-pattern">
        <VP1Pattern
          :size="88"
          :opacity="0.12"
          stroke="var(--vp-turquoise-100)"
        />
      </div>
      <div class="auth__brand-inner">
        <div class="auth__brand-mark">
          <span class="auth__brand-square" />
          <span class="auth__brand-wordmark">Alice</span>
        </div>
        <p class="auth__brand-tagline">{{ tagline }}</p>
        <p class="auth__brand-by">Valsplat · Braingineers</p>
      </div>
    </aside>

    <!-- Form panel -->
    <main class="auth__panel">
      <div class="auth__panel-inner">
        <div class="auth__mark-mobile">
          <span class="auth__brand-square" />
          <span class="auth__brand-wordmark">Alice</span>
        </div>

        <slot />
      </div>
      <footer class="auth__foot">
        <slot name="footer">
          <span>Powered by Braingineers</span>
        </slot>
      </footer>
    </main>
  </div>
</template>

<script>
import VP1Pattern from "@/components/alice/VP1Pattern.vue";

export default {
  name: "AuthShell",
  components: { VP1Pattern },
  props: {
    tagline: {
      type: String,
      default:
        "AI-powered UX research, from raw sessions to shareable insight.",
    },
  },
};
</script>

<style scoped>
.auth {
  display: flex;
  height: 100vh;
  width: 100%;
  background: var(--vp-white);
  color: var(--fg-1);
  font-family: var(--font-body);
}

/* —— Brand panel —— */
.auth__brand {
  position: relative;
  width: 42%;
  max-width: 560px;
  background: var(--vp-black);
  color: var(--vp-white);
  overflow: hidden;
  flex-shrink: 0;
}
.auth__brand-pattern {
  position: absolute;
  inset: 0;
}
.auth__brand-inner {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 16px;
  padding: 48px;
}
.auth__brand-mark {
  display: flex;
  align-items: center;
  gap: 12px;
}
.auth__brand-square {
  width: 26px;
  height: 26px;
  background: var(--accent-100);
  flex-shrink: 0;
}
.auth__brand-wordmark {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 30px;
  letter-spacing: -0.01em;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 2px;
  text-decoration-color: var(--accent-100);
}
.auth__brand-tagline {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  line-height: 1.25;
  letter-spacing: -0.01em;
  max-width: 15ch;
  margin: 0;
}
.auth__brand-by {
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--vp-grijs-80);
  margin: 0;
}

/* —— Form panel —— */
.auth__panel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 24px;
  position: relative;
}
.auth__panel-inner {
  width: 100%;
  max-width: 380px;
}
.auth__mark-mobile {
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 32px;
}
.auth__mark-mobile .auth__brand-square {
  width: 22px;
  height: 22px;
}
.auth__mark-mobile .auth__brand-wordmark {
  color: var(--vp-black);
  font-size: 24px;
}
.auth__foot {
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  text-align: center;
  font-family: var(--font-ui);
  font-size: 12px;
  color: var(--fg-3);
}

@media (max-width: 860px) {
  .auth__brand {
    display: none;
  }
  .auth__mark-mobile {
    display: flex;
  }
}
</style>
